import { GetApprovalResponseSchema } from './get-approval.schema';
export const getApprovalContract = {
    method: 'GET',
    path: '/api/v2/approval/:id',
    description: 'Read an approval with the actions the caller has on it',
    responseSchema: GetApprovalResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - neither requester, reviewer nor admin',
            404: 'Approval not found'
        }
    }
};

//# sourceMappingURL=get-approval.contract.js.map